import styled from 'styled-components';
export const Container = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    user-select: none;
    > div:nth-child(1){
        width: 250px;
        height: 250px;
        background-color: #ffffff;
        border-radius: 50%;
        overflow: hidden;
        box-shadow: 0px 10px 73px -3px rgba(0,0,0,0.1),0px 10px 15px -3px rgba(0,0,0,0.1);
        img{
            width: 100%;
            height: 100%;
            object-fit: contain;   
        }
    }
    h1{
        text-align: center ;
        font-size: 32px;
        color: #525252;
        font-weight: normal;
        margin-top: 30px; 
    }
`;